// extracted by mini-css-extract-plugin
export default {"infoCard":"HotelInfoCard_infoCard__2JE4p","header":"HotelInfoCard_header__T7qfF","picture":"HotelInfoCard_picture__zuUfl","text":"HotelInfoCard_text__UKCJN"};